import { useRender } from '@base-ui/react/use-render';
import { cn } from '../../utils/cn';
const linkStyles = 'text-body-s text-current transition-colors duration-150 ease-slide';
/**
 * Inline text link. Renders an `<a>` carrying the shared link typography by default and
 * inheriting its colour from the surrounding surface (`currentColor`); pass `render` to
 * swap in a framework-routed element, or `className` to set an explicit colour. For
 * button-styled navigation, use `ButtonLink`.
 */
export const Link = ({ className, render, ...props }) => useRender({
    render,
    defaultTagName: 'a',
    props: {
        className: cn(linkStyles, className),
        ...props,
    },
});
